import access from "@/mixins/functions/access";

export default {
    computed: {
        hasRoleAdmin: () => access.hasRoleAdmin(),
        hasRoleBoshqarSaleManager: () => access.hasRoleBoshqarSaleManager(),
        hasRoleBoshqarSaleManagerOrAdmin: () => access.hasRoleBoshqarSaleManagerOrAdmin(),
    },
}